// extracted by mini-css-extract-plugin
module.exports = {"shop-finder-skeleton":"ShopFinder_shop-finder-skeleton__i6_nZ"};